var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-barcode",
    "data-name": "Icon ionic-ios-barcode",
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.599,
    height: 131.999,
    viewBox: "0 0 171.599 131.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-1",
    d: "M33.735 127.2H16.9a1.655 1.655 0 0 1-1.65-1.65V19.95a1.655 1.655 0 0 1 1.65-1.65h16.711a6.076 6.076 0 0 0 6.064-5.775A5.42 5.42 0 0 0 37.983 8.4a7.371 7.371 0 0 0-4.909-1.65H10.8c-4.125 0-7.425 2.475-7.425 6.6v118.8c0 4.125 2.887 6.6 7.012 6.6h23.224c3.259 0 5.981-2.145 6.064-5.28a5.689 5.689 0 0 0-1.691-4.249 6.112 6.112 0 0 0-4.249-2.021z",
    transform: "translate(-3.375 -6.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-1",
    d: "M55.726 6.75H32.5c-3.919 0-7.054 3.424-5.775 7.549a4.47 4.47 0 0 0 .33.784 5.838 5.838 0 0 0 5.324 3.217h16.83a1.655 1.655 0 0 1 1.65 1.65v105.558a1.655 1.655 0 0 1-1.65 1.65H32.5a6.012 6.012 0 0 0-6.064 5.734 5.78 5.78 0 0 0 1.691 4.29 5.682 5.682 0 0 0 4.249 1.567h23.35c4.125 0 7.012-2.475 7.012-6.765V13.35c.001-4.125-2.887-6.6-7.012-6.6z",
    transform: "translate(108.86 -6.75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M13.4 12.375a5.783 5.783 0 0 0-5.775 5.734V72.6a5.775 5.775 0 0 0 11.55 0V18.109a5.783 5.783 0 0 0-5.775-5.734z",
    transform: "translate(17.327 20.625)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M32.177 78.374a5.783 5.783 0 0 0 5.775-5.734V18.109a5.775 5.775 0 0 0-11.55 0V72.6a5.792 5.792 0 0 0 5.775 5.774z",
    transform: "translate(108.69 20.625)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M27.748 10.125a5.882 5.882 0 0 0-5.775 5.94v80.478a5.777 5.777 0 1 0 11.55 0V16.065a5.882 5.882 0 0 0-5.775-5.94z",
    transform: "translate(87.133 9.675)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-1",
    d: "M17.834 10.125a5.882 5.882 0 0 0-5.775 5.94v80.478a5.855 5.855 0 0 0 5.775 5.94 5.882 5.882 0 0 0 5.775-5.94V16.065a5.855 5.855 0 0 0-5.775-5.94z",
    transform: "translate(38.885 9.675)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-1",
    d: "M22.791 11.25a5.836 5.836 0 0 0-5.775 5.857v67.444a5.776 5.776 0 1 0 11.55 0V17.107a5.836 5.836 0 0 0-5.775-5.857z",
    transform: "translate(63.009 15.15)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.41c7e40968d1868fb9cbe9b26bd1d951.svg";
export { ForwardRef as ReactComponent };